module.exports = __webpack_public_path__ + "img/i-shop-admin.43a8e0b4.svg";